<!-- eslint-disable -->
<script>
// eslint-disable-next-line
window.onload = function (e) {
  console.log('crossstore origin: ', e.origin);
  if (
    e.origin === 'http://localhost:8080'
    || e.origin === 'https://implicit.io'
  ) {
    return;
  }

  const customToken = localStorage.getItem('customToken');
  if (customToken) {
    window.postMessage(
      JSON.stringify({ success: true, customToken }),
      'https://sites.recap.io',
    );
  } else {
    window.postMessage(
      JSON.stringify({ success: false }),
      'https://sites.recap.io',
    );
  }
};

export default {
  name: 'crossStore',
};
</script>
